import { toast } from 'sonner';

// ULTRA-RELIABLE clipboard copy with multiple fallback methods
export async function copyToClipboard(text, label = 'Tekstas') {
  try {
    // Method 1: Modern Clipboard API (best for HTTPS)
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      toast.success(`${label} nukopijuota!`);
      return true;
    }
    
    // Method 2: Fallback using textarea (works on all devices)
    return fallbackCopyTextToClipboard(text, label);
    
  } catch (err) {
    console.error('Clipboard API failed, trying fallback:', err);
    return fallbackCopyTextToClipboard(text, label);
  }
}

function fallbackCopyTextToClipboard(text, label) {
  // Create textarea element
  const textArea = document.createElement('textarea');
  textArea.value = text;
  
  // Make it invisible but accessible
  textArea.style.position = 'fixed';
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.width = '2em';
  textArea.style.height = '2em';
  textArea.style.padding = '0';
  textArea.style.border = 'none';
  textArea.style.outline = 'none';
  textArea.style.boxShadow = 'none';
  textArea.style.background = 'transparent';
  textArea.style.opacity = '0';
  textArea.style.pointerEvents = 'none';
  
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  
  try {
    // iOS specific handling
    if (navigator.userAgent.match(/ipad|iphone/i)) {
      const range = document.createRange();
      range.selectNodeContents(textArea);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      textArea.setSelectionRange(0, 999999);
    } else {
      textArea.select();
    }
    
    const successful = document.execCommand('copy');
    document.body.removeChild(textArea);
    
    if (successful) {
      toast.success(`${label} nukopijuota!`);
      return true;
    } else {
      throw new Error('execCommand failed');
    }
  } catch (err) {
    console.error('Fallback copy failed:', err);
    document.body.removeChild(textArea);
    
    // Last resort: show manual copy instructions
    toast.error('Nepavyko automatiškai nukopijuoti. Prašome pažymėti tekstą rankiniu būdu ir nukopijuoti (Ctrl+C arba Command+C).');
    return false;
  }
}